export const DATA_TRACE_DISPLAY_NAMES = {
  unitId: 'Unit ID',
  unitName: 'Unit Name',
  floorPlan: 'Floor Plan',
  price: 'Price',
  availability: 'Availability',
  rent: 'Rent'
};
